import { FC } from 'react';
import { PanelPaper } from './common';
import { IconButton, Skeleton } from '@mui/material';
import { Close } from '@mui/icons-material';
import TruncatedTypography from '@components/TruncatedTypography';
import DeviceNameSpan from '@components/deviceNameSpan';
import { Trans } from '@lingui/macro';
import { MovementDataRenderer } from '@features/gateCommon';

interface Props {
  movementId: number | null;
  onClose: () => void;
}

export const PanelTitle: FC<Props> = ({ movementId, onClose }) => {
  return (
    <PanelPaper
      sx={{
        gridArea: 'title',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close" size="small">
        <Close fontSize="small" />
      </IconButton>
      <TruncatedTypography variant="h6">
        {movementId ? (
          <MovementDataRenderer
            movementId={movementId}
            render={({ gate }) => {
              return <DeviceNameSpan deviceId={gate.id} />;
            }}
            fallback={() => <Skeleton>Nombre dummy</Skeleton>}
          />
        ) : (
          <Trans>No hay dispositivo seleccionado</Trans>
        )}
      </TruncatedTypography>
    </PanelPaper>
  );
};
